import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../Box';
import Button from '../Button';
import { StyledProps, StyleProps } from '@front10';

export interface Option {
  name: string;
  value: string;
  disabled?: boolean;
  isClickable?: boolean;
}

interface Props {
  options: Option[];
  selectedOption: Option;
  /**
   * Styles for the options
   */
  optionStyles: StyledProps<$TSFixMe>;
  /**
   * Styles for the selected option
   */
  selectedOptionStyles: StyledProps<$TSFixMe>;
  /**
   * Function fired when onChange event is called
   */
  onChange: (option: Option) => void;
  /**
   * Function to render the options
   */
  renderOption: (option: Option) => JSX.Element;
}

const getOptionSelectedStyles = (
  option: Option['value'],
  selectedOption: Option['value'],
  styles: StyleProps
) => (option === selectedOption ? styles : {});

function RadioSelect(props: StyledProps<Props>) {
  const {
    options,
    selectedOption,
    optionStyles,
    selectedOptionStyles,
    onChange,
    renderOption
  } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box className={`fr-nav ${className}`} style={style}>
      {options.map((option) => {
        return renderOption && typeof renderOption === 'function' ? (
          renderOption(option)
        ) : (
          <Button
            {...optionStyles}
            {...getOptionSelectedStyles(option.value, selectedOption.value, selectedOptionStyles)}
            onClick={() => {
              if (option?.isClickable) {
                onChange(option);
              }
            }}
            key={option.value}
            disabled={option.disabled === undefined ? false : option.disabled}
          >
            {option.name}
          </Button>
        );
      })}
    </Box>
  );
}

RadioSelect.defaultProps = {
  options: [],
  optionStyles: {
    color: 'link'
  },
  selectedOptionStyles: {
    color: 'primary'
  },
  onChange: () => {},
  renderOption: null
};

RadioSelect.componentName = 'RadioSelect';

export default RadioSelect;
